import '../styles/Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <p>© 2025 Sian Beale | All rights reserved.</p>
    </footer>
  );
}

export default Footer;